/** Tanzania mobile helpers — shared across forms (GreenLeaf G1-05). */

/** Digits only, optional leading +, max 15 digits after +. */
export function normalizeTzPhone(raw: string): string {
  const trimmed = (raw || "").trim();
  if (!trimmed) return "";
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "").slice(0, 15);
  if (!digits) return hasPlus ? "+" : "";
  // Prefer +255… when user typed 0XXXXXXXXX or 255…
  if (!hasPlus && digits.startsWith("0") && digits.length === 10) {
    return `+255${digits.slice(1)}`;
  }
  if (!hasPlus && digits.startsWith("255") && digits.length === 12) {
    return `+${digits}`;
  }
  return hasPlus || digits.startsWith("255") ? `+${digits.replace(/^\+/, "")}` : digits;
}

/** Strict MSISDN used by lead capture / SMS / customer create. */
export function isValidTzMobile(phone: string): boolean {
  return /^\+255\d{9}$/.test(normalizeTzPhone(phone));
}
